import { Type } from '@angular/core';
import { SingleItemType } from '@libs/form/models';
import { ActionItemsMap, ActionsItemComponent } from './actions';
import { ContentItemComponent, ContentItemsMap } from './content';
import { InputItemComponent, InputItemsMap } from './input';

export type SingleItemComponent =
  | ActionsItemComponent
  | ContentItemComponent
  | InputItemComponent;

export const SingleItemsMap: Omit<Record<SingleItemType, Type<SingleItemComponent>>, 'external'> = {
  ...ActionItemsMap,
  ...ContentItemsMap,
  ...InputItemsMap,
};
